import { capitalizeFirstLetter } from '../common/utils';
import { normalizeManagerExternals } from '../user';

import {
  ICabinetManager,
  IManagerBase,
  IManagerRoleEntity,
  IProjectManager,
  IProjectManagerEntity
} from './client';
import {
  CabinetManagerServer,
  ManagerBaseServer,
  ProjectManagerEntityServer,
  ProjectManagerServer,
  ManagerRoleEntity,
  CabinetManagerRoleType,
  ProjectManagerRoleType
} from './server';

export const normalizeManagerBase = (raw: ManagerBaseServer): IManagerBase => ({
  id: raw._id,
  name: raw.name,
  email: raw.email
});

export const normalizeProjectManager = (
  raw: ProjectManagerServer
): IProjectManager => ({
  ...normalizeManagerBase(raw),
  projectRole: raw.project_role,
  isRoleChangeable: raw.is_role_changeable
});

export const normalizeCabinetManager = (
  raw: CabinetManagerServer
): ICabinetManager => ({
  ...normalizeManagerBase(raw),
  cabinetRole: raw.cabinet_role,
  projects: raw.projects.map(normalizeProjectManagerEntity),
  isRoleChangeable: raw.is_role_changeable,
  externalIds: normalizeManagerExternals(raw.external_ids)
});

export const normalizeProjectManagerEntity = (
  raw: ProjectManagerEntityServer
): IProjectManagerEntity => ({
  id: raw._id,
  name: raw.name,
  projectRole: raw.role
});

export const normalizeCabinetRoleEntity = (
  raw: ManagerRoleEntity<CabinetManagerRoleType>
): IManagerRoleEntity<CabinetManagerRoleType> => ({
  ...raw,
  name: (t) =>
    capitalizeFirstLetter(
      t(`manager.roles.cabinet.${raw.role}.name`, {
        ns: 'entities'
      })
    ),
  description: (t) =>
    t(`manager.roles.cabinet.${raw.role}.description`, {
      ns: 'entities'
    })
});

export const normalizeProjectRoleEntity = (
  raw: ManagerRoleEntity<ProjectManagerRoleType>
): IManagerRoleEntity<ProjectManagerRoleType> => ({
  ...raw,
  name: (t) =>
    capitalizeFirstLetter(
      t(`manager.roles.project.${raw.role}.name`, {
        ns: 'entities'
      })
    ),
  description: (t) =>
    t(`manager.roles.project.${raw.role}.description`, {
      ns: 'entities'
    })
});
